import { Component, Watch, Prop } from 'vue-property-decorator';
import { Block } from '../../../helpers/components';
import { BaseBlock } from '../../base-block';
import { ApartmentPriceTable } from '../../../components/apartment-price-table/apartment-price-table';
import { ApartmentSearchStatsDTO } from '../../../model/ApartmentSearchStatsDTO';
import { ApartmentSearchDTO } from '../../../model/ApartmentSearchDTO';
import { ApartmentSearchSortType } from '../../../enums/ApartmentSearchSortType';
import { LocationDTO } from '../../../model/LocationDTO';
import { ApartmentSearchFilterDTO } from '@/model/ApartmentSearchFilterDTO';
import { ApartmentSearchSortDirection } from '../../../enums/ApartmentSearchSortDirection';
import { formatDateLocal } from '@/helpers/dates';
import { ApartmentPriceCards } from '../../../components/apartment-price-cards/apartment-price-cards';
import ApartmentPriceViewSwitch from '../../../components/apartment-price-view-switch/apartment-price-view-switch';
import { Pagination } from '../../../components/pagination/pagination';

@Block()
@Component({
	components: {
		ApartmentPriceTable,
		ApartmentPriceCards,
		ApartmentPriceViewSwitch,
		Pagination
	}
})
export class ApartmentsOverviewResultBlock extends BaseBlock {
	@Prop() location: LocationDTO;

	results: ApartmentSearchDTO[] = null;
	nextStats: ApartmentSearchStatsDTO = null;
	limit = 24;
	offset = 0;
	totalPages = 0;
	currentPage = 1;
	morePage = 1;

	fetchingResults: boolean = false;
	isTableView: boolean = true;

	@Watch('$route', {immediate: true})
	protected searchFilterChanged() {
		if (this.shouldSearch) {
			this.load();
		}
	}

	load() {
		this.results = null;

		this.limit = 24;
		this.offset = 0;
		this.fetchResults();
	}

	loadMore() {
		this.offset += this.limit;
		this.morePage++;
		this.fetchResults(true);
	}

	get shouldSearch() {
		return this.$route.query.search === 'true';
	}

	get searchFilter() {
		return {
			...this.$route.query,
			locationIds: [this.location.id],
			locationCatNo: [this.location.catalogMarketingNumber],
		} as ApartmentSearchFilterDTO;
	}

	get searchSort() {
		return parseInt(this.$route.query.sort) as ApartmentSearchSortType || ApartmentSearchSortType.TotalPrice;
	}

	get searchSortDirection() {
		return parseInt(this.$route.query.sortDirection) as ApartmentSearchSortDirection || ApartmentSearchSortDirection.Up;
	}

	get currentDateFormated() {
		return formatDateLocal(this.getCurrentDate());
	}

	async fetchResults(append: boolean = false) {
		this.fetchingResults = true;

		const results = await this.$apartmentService.fetchApartments(
			this.searchFilter,
			this.searchSort,
			this.searchSortDirection,
			this.limit,
			this.offset
		);

		const nextStats = await this.$apartmentService.fetchSearchStats(
			this.searchFilter,
			this.limit,
			this.offset + this.limit
		);

		this.nextStats = nextStats;
		this.totalPages = Math.ceil(this.nextStats.totalCount / this.limit);

		if (append) {
			this.results = this.results.concat(results);
		} else {
			this.results = results;
		}

		this.fetchingResults = false;
	}

	onIsTableViewChanged(value: boolean) {
		this.isTableView = value;
	}

	async onPageChanged(newPage: number) {
    	this.currentPage = newPage;
		this.morePage = newPage;

		this.offset = (this.currentPage - 1) * this.limit;
		await this.fetchResults(false);
		this.$nextTick(() => {
			this.scrollTo();
		})
  	}

	scrollTo() {
      (this.$refs.targetTable as HTMLElement).scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
}

export default ApartmentsOverviewResultBlock;
